export default function (DOMElement, loaderInstance) {
    if (DOMElement) {
        DOMElement.removeChild(loaderInstance.$el);
    }
}
